import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i1.5
// this icon looks to be outdated, see 24x24 version
import React from 'react';
import IconWrap from '../IconWrap';
const BirthdayCake = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M12 9V8h1v1h4a1 1 0 0 1 1 1v4h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v1H2v-1a1 1 0 0 1 1-1h1v-4a1 1 0 0 1 1-1h2v-4a1 1 0 0 1 1-1h4zm.5-6l1.193 1.338a1.598 1.598 0 1 1-2.386 0L12.5 3z"
    }))));
BirthdayCake.displayName = 'BirthdayCake';
export default BirthdayCake;
